export default "__VITE_ASSET__0788110a__"